import React from 'react'
import { graphql } from 'gatsby'
import DefaultPage from '../components/template-parts/DefaultPage'
import WpGroupPage from '../components/template-parts/wordpress-group-page'
import WpProductPage from '../components/template-parts/wordpress-product-page'
import WpAggregatePage from '../components/template-parts/wordpress-aggregate-page'

const Page = ({ data }) => {
    if (
        typeof window !== 'undefined' &&
        window.location.href.includes('chapters.uwalumni.com')
    ) {
        const fixedUrl = window.location.href.replace(
            'chapters.uwalumni.com',
            'www.uwalumni.com',
        )
        window.location.replace(fixedUrl)
    }

    const { page } = data
    const { template, ancestors } = page

    if (ancestors) {
        // this page has a parent

        const groupSlug = 'groups'

        const topParent = ancestors.nodes[ancestors.nodes.length - 1]
        if (topParent?.slug && topParent.slug === groupSlug) {
            if (ancestors.nodes.length === 1) {
                return <WpGroupPage page={page} />
            }
        }
    }

    if (template) {
        const { templateName } = template
        switch (templateName) {
            case 'Aggregate (Product) Page':
                return <WpAggregatePage page={page} />
            case 'Product/General Page':
            case 'Product Template':
            case 'General Template':
                return <WpProductPage page={page} />
            case 'Default':
            default:
                return <DefaultPage page={page} />
        }
    }
    return <DefaultPage page={page} />
}

export default Page

export const query = graphql`
    query all($id: String!) {
        page: wpPage(id: { eq: $id }) {
            title
            excerpt
            link
            heroIntroSection {
                introHeading
                introExcerpt
                heroHeading
            }
            content
            slug
            menuOrder
            hideFromMenu {
                hideFromMenu
                fieldGroupName
            }
            ...SidebarMenu
            ...Children
            template {
                ... on WpDefaultTemplate {
                    templateName
                }
                ... on WpTemplate_AggregateProductPage {
                    templateName
                }
                ... on WpTemplate_HomePage {
                    templateName
                }
                ... on WpTemplate_TopLevelPage {
                    templateName
                }
                ... on WpProductTemplate {
                    templateName
                }
                ... on WpGeneralTemplate {
                    templateName
                }
            }
            featuredImage {
                node {
                    mediaDetails {
                        width
                    }
                    localFile {
                        ...HeroImageNew
                        publicURL
                    }
                }
            }
            introButtons {
                introButtons {
                    buttonLink {
                        ... on WpPage {
                            id
                            uri
                        }
                        ... on WpPost {
                            id
                            uri
                        }
                        ... on WpEvent {
                            id
                            uri
                        }
                    }
                    buttonExternalLinkUrl
                    buttonText
                    namedAnchor
                }
            }
            groups {
                nodes {
                    slug
                    events {
                        nodes {
                            title
                            startDate
                            endDate
                            url
                            link
                            venue {
                                title
                                city
                                state
                            }
                            excerpt
                            products {
                                nodes {
                                    name
                                }
                            }
                            featured
                            featuredImage {
                                node {
                                    localFile {
                                        ...CardImage
                                        publicURL
                                    }
                                }
                            }
                            privatePost {
                                isprivate
                            }
                        }
                    }
                }
            }
            blocks {
                order
                name
                order
                isDynamic
                originalContent
                dynamicContent
                saveContent
                attributesJSON
                innerBlocks {
                    order
                    name
                    order
                    isDynamic
                    originalContent
                    dynamicContent
                    saveContent
                    ... on WpCoreImageBlock {
                        mediaItem {
                          node {
                            localFile {
                              childImageSharp {
                                gatsbyImageData
                              }
                            }
                          }
                        }
                      }
                    innerBlocks {
                        order
                        name
                        order
                        originalContent
                        dynamicContent
                        saveContent
                        innerBlocks {
                            order
                            name
                            order
                            originalContent
                            dynamicContent
                            saveContent
                        }
                    }
                }
            }
            products {
                nodes {
                    slug
                    name
                    ...ProductEventCards
                    ...ProductPostCards
                }
            }
        }
    }
`
